import { render } from "./tagList.vue?vue&type=template&id=5b31fa24&scoped=true"
import script from "./tagList.vue?vue&type=script&lang=js"
export * from "./tagList.vue?vue&type=script&lang=js"

import "./tagList.vue?vue&type=style&index=0&id=5b31fa24&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b31fa24"]])

export default __exports__